import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { storage as LocalStorage } from 'services/config/storage';
import IroExamAlertModal from '../components/IroExamAlert/IroExamAlertModal';
import SelectProfile from '../components/selectProfile/SelectProfile';
import "assets/stylesheet/global.scss";

const GlobalModalWrapper = ({ location }) => {
    const [hasChild, setHasChild] = useState(!!LocalStorage?.fetch?.defaultChild());
    const [showAlert, setShowAlert] = useState(false);
    const [showSelectProfile, setShowSelectProfile] = useState(false);
    const [hasChecked, setHasChecked] = useState(false);

    useEffect(() => {
        // One-time polling until childData is ready
        const checkConditions = () => {
            // console.log("checking...")
            const childExists = !!LocalStorage?.fetch?.defaultChild();
            setHasChild(childExists);
            // console.log("childExistes",childExists)
            const shouldShowProfile =
                LocalStorage.fetch.parentData()?.is_teacher !== null &&
                LocalStorage.fetch.childData()?.list?.filter((child) => child.school_code !== null)?.length > 1;

            let visited = sessionStorage.getItem("visited");
            if (visited) visited = JSON.parse(visited)

            // console.log(visited,shouldShowProfile)

            if (shouldShowProfile && !visited) {
                setShowSelectProfile(true);
            }
            else{
                setShowAlert(true);
            }

            if (childExists) setHasChecked(true); // Stop polling once data is valid
        };

        checkConditions(); // run once immediately

        const interval = setInterval(() => {
            if (!hasChecked) {
                checkConditions();
            }
        }, 500);

        return () => clearInterval(interval);
    }, [hasChecked, LocalStorage?.fetch?.defaultChild()]);

    const handleProfileClose = () => {
        setShowSelectProfile(prev => !prev);
        setShowAlert(prev=>!prev);
    };

    if (!hasChild) return null;

    // console.log(showSelectProfile)

    return (
        <>
            {showSelectProfile && <SelectProfile onClose={handleProfileClose} />}
            {!showSelectProfile && showAlert && <IroExamAlertModal />}
        </>
    );
};

export default withRouter(GlobalModalWrapper);
